import React from 'react';
export default function MenuItem(_ref) {
  var item = _ref.item,
    nextValue = _ref.nextValue,
    moveToNext = _ref.moveToNext,
    frontendStyles = _ref.frontendStyles;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 10,
      paddingBottom: 10
    },
    className: "menuItem flex-box items-center content-space-between bm-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, item.link ? /*#__PURE__*/React.createElement("a", {
    style: {
      backgroundColor: frontendStyles.burgerNavigation.background,
      color: frontendStyles.burgerNavigation.color
    },
    href: item.link,
    dangerouslySetInnerHTML: {
      __html: item.value
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "pointer",
    style: {
      backgroundColor: frontendStyles.burgerNavigation.background,
      color: frontendStyles.burgerNavigation.color
    },
    href: item.link,
    dangerouslySetInnerHTML: {
      __html: item.value
    }
  })), nextValue && /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return moveToNext(item);
    },
    className: "right_icon pointer",
    style: {
      backgroundColor: frontendStyles.burgerNavigation.background,
      color: frontendStyles.burgerNavigation.color,
      width: 40,
      textAlign: 'right'
    }
  }));
}